import type { ErrorDialogSnapshot, ErrorDialogState } from "./mutation-feedback.type";

const CLOSED: ErrorDialogSnapshot = { open: false, error: null };

const createErrorDialogStore = () => {
  let snapshot: ErrorDialogSnapshot = CLOSED;
  const listeners = new Set<() => void>();

  const emit = () => {
    for (const listener of listeners) listener();
  };

  return {
    subscribe: (listener: () => void) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot: (): ErrorDialogSnapshot => snapshot,
    open: (error: ErrorDialogState) => {
      snapshot = { open: true, error };
      emit();
    },
    // The payload outlives the close so the dialog content stays mounted while Radix
    // runs its dismiss sequence; unmounting it in the same commit strands the overlay.
    close: () => {
      if (!snapshot.open) return;
      snapshot = { open: false, error: snapshot.error };
      emit();
    },
  };
};

type ErrorDialogStore = ReturnType<typeof createErrorDialogStore>;

export { createErrorDialogStore };
export type { ErrorDialogStore };
